<template>
  <div class="simple-rich-editor">
    <div class="editor-toolbar">
      <button type="button" class="toolbar-btn" :class="{ active: isActive('bold') }" @click="exec('bold')" title="加粗" aria-label="加粗"><b>B</b></button>
      <button type="button" class="toolbar-btn" :class="{ active: isActive('italic') }" @click="exec('italic')" title="斜体" aria-label="斜体"><i>I</i></button>
      <button type="button" class="toolbar-btn" :class="{ active: isActive('underline') }" @click="exec('underline')" title="下划线" aria-label="下划线"><u>U</u></button>
      <span class="toolbar-divider"></span>
      <button type="button" class="toolbar-btn" @click="exec('insertUnorderedList')" title="无序列表" aria-label="无序列表"><i class="el-icon-s-unfold"></i></button>
      <button type="button" class="toolbar-btn" @click="exec('insertOrderedList')" title="有序列表" aria-label="有序列表"><i class="el-icon-s-fold"></i></button>
      <span class="toolbar-divider"></span>
      <select class="toolbar-select" @change="exec('fontSize', $event.target.value); $event.target.value = ''" title="字体大小" aria-label="字体大小">
        <option value="">字号</option>
        <option value="1">小</option>
        <option value="3">正常</option>
        <option value="5">大</option>
        <option value="7">特大</option>
      </select>
      <input type="color" class="toolbar-color" @change="exec('foreColor', $event.target.value); $event.target.value = ''" title="字体颜色" aria-label="字体颜色" />
      <span class="toolbar-divider"></span>
      <button type="button" class="toolbar-btn" @click="exec('removeFormat')" title="清除格式" aria-label="清除格式"><i class="el-icon-brush"></i></button>
    </div>
    <div
      ref="editor"
      class="editor-content"
      contenteditable="true"
      role="textbox"
      aria-label="富文本编辑器"
      @input="onInput"
      @blur="onBlur"
      v-html="innerValue"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SimpleRichEditor',
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      innerValue: this.value,
      isFocused: false
    }
  },
  watch: {
    value(val) {
      const editorHtml = this.$refs.editor ? this.$refs.editor.innerHTML : ''
      if (val !== editorHtml) {
        this.innerValue = val
      }
    }
  },
  methods: {
    exec(command, value = null) {
      document.execCommand(command, false, value)
      this.$refs.editor.focus()
      this.emitChange()
    },
    isActive(command) {
      return document.queryCommandState(command)
    },
    onInput() {
      this.emitChange()
    },
    onBlur() {
      this.emitChange()
    },
    emitChange() {
      const html = this.$refs.editor.innerHTML
      this.$emit('input', html)
    }
  }
}
</script>

<style scoped>
.simple-rich-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}
.toolbar-btn {
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #606266;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.toolbar-btn:hover {
  background: #e4e7ed;
  border-color: #c0c4cc;
}
.toolbar-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}
.toolbar-divider {
  width: 1px;
  height: 18px;
  background: #dcdfe6;
  margin: 0 4px;
}
.toolbar-select {
  height: 32px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: #606266;
  font-size: 12px;
  padding: 0 4px;
  cursor: pointer;
  outline: none;
}
.toolbar-select:hover {
  background: #e4e7ed;
  border-color: #c0c4cc;
}
.toolbar-color {
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  padding: 2px;
}
.toolbar-color:hover {
  background: #e4e7ed;
  border-color: #c0c4cc;
}
.editor-content {
  min-height: 120px;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
  outline: none;
}
.editor-content:empty:before {
  content: attr(placeholder);
  color: #c0c4cc;
}
.editor-content >>> ul,
.editor-content >>> ol {
  padding-left: 20px;
  margin: 8px 0;
}
.editor-content >>> p {
  margin: 0 0 8px 0;
}
.editor-content >>> p:last-child {
  margin-bottom: 0;
}
</style>
